import { axiosWithHeaders } from '../utils/axiosGenerator';
import config from './config.api';
const auth = axiosWithHeaders({
    service: 'entitlements',
    config,
    injectTenantId: true,
    timeout: 30000,
});
export default auth;
